<template>
  <a-select
    style="width: 100%"
    v-model="lang"
    show-search
    @change="handleChange"
    :filter-option="filterOption"
    option-filter-prop="children"
    allowClear
    placeholder="请选择语言"
    :size="size"
    :disabled="disabled"
  >
    <a-select-option v-for="item in langOptions" :key="item.langCode" :value="item.langCode">{{
      item.langName
    }}</a-select-option>
  </a-select>
</template>

<script>
import { queryCountryOptionsApi } from '@/api/Site/Create'
export default {
  data() {
    return {
      langOptions: [],
      lang: ''
    }
  },
  props: {
    value: {},
    size: {
      type: String,
      default: 'default'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.queryCountryOptions()
  },
  methods: {
    async queryCountryOptions() {
      let res = await queryCountryOptionsApi()
      let { code, msg, extra } = res
      if (code == '200') {
        this.langOptions = extra.langs
      } else {
        this.$message.error(msg)
      }
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleChange(val) {
      this.$emit('input', val)
    }
  },
  watch: {
    value: {
      handler() {
        this.lang = this.value
      },
      immediate: true
    }
  }
}
</script>
<style lang="less" scoped></style>
